import { render, staticRenderFns } from "./PointsLogs.vue?vue&type=template&id=75850e7d"
import script from "./PointsLogs.vue?vue&type=script&lang=js"
export * from "./PointsLogs.vue?vue&type=script&lang=js"
import style0 from "./PointsLogs.vue?vue&type=style&index=0&id=75850e7d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports